import { Component, OnInit } from '@angular/core';
import { getActiveProjectSelector } from '../projects/projects.reducer';
import { Configuration } from '../shared/domain/configuration.model';
import { IState } from '../../shared/models/state';
import { Store } from '@ngrx/store';
import { AlertPaymentService } from '../../shared/services/alert-payment.service';

@Component({
  selector: 'cc-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.scss']
})
export class LeftMenuComponent implements OnInit {
  private activeType: string;
  private creatingNewProject = false;
  public failedPayment: boolean;

  constructor(private store: Store<IState>, public alertPaymentService: AlertPaymentService) {
    this.store.select(getActiveProjectSelector).subscribe((config: Configuration | null) => {
      if (config && config.projectId) {
        this.activeType = config.activeType;
      } else {
        this.creatingNewProject = true;
      }
    });
  }

  ngOnInit() {
    this.alertPaymentService.onActivatePaymentAlert.subscribe(isPaymentFailed => {
      this.failedPayment = isPaymentFailed;
    });
  }

  get isCreatingNewProject() {
    return this.creatingNewProject;
  }

  get creatorPageForActiveType() {
    switch (this.activeType) {
      case 'POPUP':
        return 'popup';
      case 'BUBBLE':
        return 'bubble';
      default:
        return 'select';
    }
  }
}
